<template>
    <div class="basicInformation">
        <form class="personal_information" action="" method="post">
            <h3>{{$t('personal_data')}}</h3>
            <div class="head-portrait">
                <label>{{$t('head_portrait')}}</label>
                <input id="pic1" type="hidden" value="" name="photo" v-model="form1.photo" class="image_photo">
                <img id="pic" :src="imgUrl?imgUrl:require('../../assets/images/personalCenter/photo.png')">
                <a href="javascript:;" class="file">
                    <input type="file" name="" id="headPortraitUpload" @change="headPortraitListener($event)">
                </a>
            </div>
            <div class="import">
                <label>{{$t('compellation')}}</label>
                <input type="text" name="real_name" v-model="form1.real_name" :placeholder="$t('placeholder_name')"></div>
            <label>{{$t("sex")}}</label>
            <div class="select">
                <select name="sex" v-model="form1.sex" class="sel">
                    <option value="1">{{$t("sex_men")}}</option>
                    <option value="2">{{$t("sex_women")}}</option>
                </select>
            </div>
            <label>{{$t('birthday')}}}</label>
            <input type="date" v-model="form1.birthday" name="birthday" :placeholder="$t('placeholder_birth')" @blur="selectBrithTime()">
            <div class="import">
                <label>{{$t('contact_way')}}}</label>
                <input type="text" name="tel" v-model="form1.tel" :placeholder="$t('placeholder_way')">
            </div>
            <div class="import">
                <label>{{$t('email')}}}</label>
                <input type="text" name="email" v-model="form1.email" :placeholder="$t('placeholder_mail')">
            </div>
            <div class="import">
                <label>{{$t('address_now')}}</label>
                <input type="text" name="now_city" v-model="form1.now_city" :placeholder="$t('placeholder_address')">
            </div>
           <div class="height">
                <label>{{$t('height')}}</label>
                <input type="text" name="height" v-model="form1.height" :placeholder="$t('placeholder_height')">cm
            </div>
            <div class="height">
                <label>{{$t('weight')}}</label>
                <input type="text" name="weight" v-model="form1.weight" :placeholder="$t('placeholder_weight')">kg
            </div>
            <label>{{$t('academic')}}</label>
            <div class="select">
                <select name="education" v-model="form1.education" class="sel">
                    <option value="1">{{$t('academic_lists[0]')}}</option>
                    <option value="2">{{$t('academic_lists[1]')}}</option>
                    <option value="3">{{$t('academic_lists[2]')}}</option>
                    <option value="4">{{$t('academic_lists[3]')}}</option>
                    <option value="5">{{$t('academic_lists[4]')}}</option>
                    <option value="6">{{$t('academic_lists[5]')}}</option>
                    <option value="7">{{$t('academic_lists[6]')}}</option>
                    <option value="8">{{$t('academic_lists[7]')}}</option>
                </select>
            </div>

            <label>{{$t('learning')}}:</label>
            <div class="select">
                <select name='form' class="sel" v-model="form1.form">
                    <option value="1">{{$t('learning_lists[0]')}}</option>
                    <option value="2">{{$t('learning_lists[1]')}}</option>
                    <option value="3">{{$t('learning_lists[2]')}}</option>
                    <option value="4">{{$t('learning_lists[3]')}}</option>
                    <option value="5">{{$t('learning_lists[4]')}}</option>
                </select>
            </div>
        </form>
        <form class="job_intention" action="" method="post">
            <h3>{{$t("job_intention")}}</h3>
            <div class="import">
                <label>{{$t("expected_salary")}}</label>
                <input type="text" name="expected_salary" v-model="form1.expected_salary" :placeholder="$t('placeholder_salary')">
            </div>
            <div class="import">
                <label>{{$t('arrival_time')}}}</label>
                <input type="text" name="arrival_time" v-model="form1.arrival_time" :placeholder="$t('placeholder_arrival')">
            </div>
            <input type="text" name="resume_id" v-model="form1.resume_id" style="border:none; font-size: 0">
        </form>
        <span class="info_btn" @click="submitForm1()">{{$t('next')}}</span>

    </div>
</template>
<script>
import { DatetimePicker } from "mint-ui";
export default {
  name: "basicInformation",
  inject: ["showMsg"],
  components: {
    DatetimePicker
  },
  data: function() {
    return {
      base64head: "" /*定义全局变量存贮图片信息*/,
      imgUrl: "",
      file: "",
      form1: {
        real_name: "",
        birthday: "",
        email: "",
        now_city: "",
        expected_salary: "",
        height: "",
        weight: "",
        arrival_time: "",
        resume_id: "",
        sex: "",
        education: "",
        form: "",
        photo: "",
        tel: ""
      },
      regTel: /^1[345789]\d{9}$/
    };
  },
  created: function() {
    this.getUserInfo1();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "base_info");
  },
  methods: {
    /*头像上传监听*/
    headPortraitListener(e) {
      //console.log(e);整个事件
      //FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件
      // （或原始数据缓冲区）的内容，
      // 使用 File 或 Blob 对象指定要读取的文件或数据。
      //file.type.match('image.*')检查图片的类型
      //reader文件读取，result 就是图片base64的数据
      let file = e.target.files[0];
      this.file = file;
      // console.log(this.file);
      let reader = new FileReader();
      let that = this;
      reader.readAsDataURL(file);
      /*  if (((file.size).toFixed(2)) >= (100 * 1024)) {
                      Toast("请上传小于100k的图片");
                      return false;
                  }*/
      // if (file && file.type.match('image.*')) {
      //     reader.readAsDataURL(file);
      // }
      reader.onload = function(e) {
        //为了解决在onload事件未被触发时，无法打印出reader.result。
        //当 FileReader 读取文件的方式为  readAsArrayBuffer, readAsBinaryString,
        // readAsDataURL 或者 readAsText 的时候，会触发一个 load 事件。
        // 从而可以使用  FileReader.onload 属性对该事件进行处理。
        that.base64head = reader.result;
        //这里得this指向reader，
        that
          .$http({
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            method: "post",
            url: that.weburl + "/home/job/imgSave",
            dataType: "json",
            data: { image: that.base64head }
          })
          .then(res => {
            if (res.data.status === 1) {
              that.imgUrl = that.weburl + res.data.result;
            }
          })
          .catch(() => {
            this.showMsg(this.$t("error_msg"));
          });
      };
    },
    selectBrithTime() {},
    checkEmail(str) {
      let reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      return reg.test(str);
    },
    /**
     * @return {boolean}
     */
    CheckName(real_name) {
      let username = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
      return username.test(real_name);
    },
    getPersonalData() {
      this.$http({
        method: "post",
        url: this.weburl + "/home/job/getUserInfo",
        dataType: "json"
      })
        .then(res => {
          if (res.data.status === 1) {
            if (
              res.data.result == null ||
              res.data.result === undefined ||
              res.data.result === ""
            ) {
              //用户没有填过任何信息
              this.showMsg(res.data.msg);
            } else {
              //用户曾填入过信息
              this.getUserData(res.data.result);
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getUserInfo1() {
      //判断是否登入
      this.$http({
        method: "post",
        url: this.weburl + "Home/User/checkLogin",
        dataType: "json"
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              this.getPersonalData();
            } else {
              this.$router.push({ path: "/login" });
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getUserData(data) {
      //用户曾填入过信息
      this.form1.real_name = data.real_name == "0" ? "" : data.real_name;
      this.form1.birthday = data.birthday == "0" ? "" : data.birthday;
      this.form1.email = data.email == "0" ? "" : data.email;
      this.form1.now_city = data.now_city == "0" ? "" : data.now_city;
      this.form1.expected_salary =
        data.expected_salary == "0" ? "" : data.expected_salary;
      this.form1.height = data.height == "0" ? "" : data.height;
      this.form1.weight = data.weight == "0" ? "" : data.weight;
      this.form1.arrival_time =
        data.arrival_time == "0" ? "" : data.arrival_time;
      this.form1.resume_id = data.resume_id;
      this.imgUrl = this.weburl + data.photo;
      this.form1.tel = data.tel == "0" ? "" : data.tel;
      switch (data.sex) {
        case 1:
          this.form1.sex = "1";
          break;
        case 2:
          this.form1.sex = "2";
          break;
      }
      switch (data.form) {
        case 1:
          this.form1.form = "1";
          break;
        case 2:
          this.form1.form = "2";
          break;
        case 3:
          this.form1.form = "3";
          break;
        case 4:
          this.form1.form = "4";
          break;
        case 5:
          this.form1.form = "5";
          break;
      }
      switch (data.education) {
        case 1:
          this.form1.education = "1";
          break;
        case 2:
          this.form1.education = "2";
          break;
        case 3:
          this.form1.education = "3";
          break;
        case 4:
          this.form1.education = "4";
          break;
        case 5:
          this.form1.education = "5";
          break;
        case 6:
          this.form1.education = "6";
          break;
        case 7:
          this.form1.education = "7";
          break;
        case 8:
          this.form1.education = "8";
          break;
      }
    },
    submitForm1() {
      // let formData = new FormData($(this.$el).find(".import-form")[0]);
      // let form1 =$(this.$el).find('.personal_information').serialize();
      // console.log($(this.$el).find('.personal_information'));
      //提交表单
      // console.log(this.imgUrl);
      if (!this.CheckName(this.form1.real_name)) {
        this.showMsg("请输入正确姓名");
        return false;
      }
      if (!this.checkEmail(this.form1.email)) {
        this.showMsg("邮箱格式错误！");
        return false;
      }
      if (!this.regTel.test(this.form1.tel)) {
        this.showMsg("请输入联系方式");
        return false;
      }
      if (this.form1.now_city === "") {
        this.showMsg("请填入现居地址");
        return false;
      }
      if (this.form1.expected_salary === "") {
        this.showMsg("请输入期望薪资");
        return false;
      }
      if (this.form1.arrival_time === "") {
        this.showMsg("请到岗时间");
        return false;
      }
      this.form1.photo = this.imgUrl.replace(this.weburl, "");
      this.$http({
        method: "post",
        url: this.weburl + "/home/job/userinfoHandle",
        dataType: "json",
        data: this.form1
      })
        .then(res => {
          if (res.data.status === 1) {
            this.$router.push({
              name: `resume`,
              params: { id: this.$route.params.id }
            });
          } else {
            this.showMsg(res.data.msg);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    //计算属性，
    end_information: function() {
      return this.$store.state.endPage.end_information;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/information.less";

.basicInformation {
  & > form {
    .padding;
    .border-bottom(5px; @bg);
    font-size: @font - 0.1;
    &.job_intention {
      border-bottom: none;
    }
    h3 {
      font-size: @font;
      height: 30px;
    }
    .height {
      input {
        width: 40%;
      }
    }
  }
  .info_btn {
    .btn;
    display: block;
    .width;
  }
}
</style>
